var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitingInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C37.7025 5.15406e-07 48 10.2975 48 23V25C48 37.7025 37.7025 48 25 48H23C10.2975 48 0 37.7025 0 25V23C5.1544e-07 10.2975 10.2975 0 23 0H25Z",
    fill: "#DAE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 31.3166H29.5893C28.736 31.3166 27.9253 31.6472 27.328 32.2446L25.504 34.0472C24.672 34.8686 23.3173 34.8686 22.4853 34.0472L20.6613 32.2446C20.064 31.6472 19.2427 31.3166 18.4 31.3166H17.6C15.8293 31.3166 14.4 29.8979 14.4 28.1486V16.5112C14.4 14.7619 15.8293 13.3433 17.6 13.3433H30.4C32.1707 13.3433 33.6 14.7619 33.6 16.5112V28.1486C33.6 29.8873 32.1707 31.3166 30.4 31.3166Z",
    fill: "#DAE5FF",
    stroke: "#5173C8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9977 21.8671C25.3703 21.8671 26.483 20.7544 26.483 19.3818C26.483 18.0092 25.3703 16.8965 23.9977 16.8965C22.6251 16.8965 21.5123 18.0092 21.5123 19.3818C21.5123 20.7544 22.6251 21.8671 23.9977 21.8671Z",
    fill: "#DAE5FF",
    stroke: "#5173C8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.265 27.904C28.265 25.984 26.3557 24.4268 23.9984 24.4268C21.641 24.4268 19.7317 25.984 19.7317 27.904",
    fill: "#DAE5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.265 27.904C28.265 25.984 26.3557 24.4268 23.9984 24.4268C21.641 24.4268 19.7317 25.984 19.7317 27.904",
    stroke: "#5173C8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitingInterview);
export default __webpack_public_path__ + "static/media/recruitingInterview.ae09d9eee3e7e868514136cff913ea91.svg";
export { ForwardRef as ReactComponent };